import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Modal, Typography } from 'antd';
import { useAntdToken } from 'common/hooks/useAntdToken';
import React from 'react';

interface Employee {
  trackingId: number;
  employeeId: string;
  trackingType: string;
  timestamp: string;
  image_id: string;
  emp_name: string;
  image_content_type: string;
  image_event: string;
}

interface CommonMonitoringImageModalProps {
  modalVisible: boolean;
  currentImageIndex: number | null;
  employeeData: Employee[];
  setModalVisible: (visible: boolean) => void;
  setCurrentImageIndex: React.Dispatch<React.SetStateAction<number | null>>;
  thumbnailsToShow?: Employee[]; // Optional to handle undefined cases
  handleThumbnailClick: (index: number) => void;
  goToPrevPage: () => void;
  goToNextPage: () => void;
}

const CommonMonitoringImageModal: React.FC<CommonMonitoringImageModalProps> = ({
  modalVisible,
  currentImageIndex,
  employeeData,
  setModalVisible,
  setCurrentImageIndex,
  thumbnailsToShow = [],
  handleThumbnailClick,
  goToPrevPage,
  goToNextPage,
}) => {
  // const index = currentImageIndex ?? 0
  // console.log('emp data from modal ===========',employeeData[index]?.soci)
  const possibleKeys = [
    'social_media_history_event',
    'meeting_history_event',
    'chat_history_event',
    'email_history_event',
  ];
  const token = useAntdToken()

  const index = currentImageIndex ?? 0;
  const selectedEmployee = employeeData[index];

  const found = possibleKeys.find((key) => {
    const value = (selectedEmployee as any)?.[key];
    return value && value !== '';
  });
  // const result = found
  //   ? { key: found, value: (selectedEmployee as any)[found] }
  //   : null;
  let result: any;

  if (found) {
    const rawValue = (selectedEmployee as any)[found];

    try {
      const parsed = JSON.parse(rawValue);

      // If it's an error message, just return the error string
      if (parsed?.error) {
        result = parsed.error;
      } else if (parsed?.response) {
        result = parsed?.response;
      } else {
        result = 'N/A';
      }
    } catch (e) {
      // If rawValue is not valid JSON (like HTML), split it line-by-line
      result =
        typeof rawValue === 'string'
          ? rawValue.split(/\r?\n/).join(' ')
          : rawValue;
    }
  }

  return (
    <Modal
      visible={modalVisible}
      onCancel={() => setModalVisible(false)}
      footer={null}
      centered
      bodyStyle={{ textAlign: 'center', padding: 0 }}
      className="min-w-[96%] !p-0"
      style={{ backgroundColor: '#ffffff36 !important' }}
    >
      {currentImageIndex !== null && (
        <div className="relative">
          <div className="relative w-full">
            {/* Large Image Display */}
            <div className="relative min-h-[80vh] flex flex-col justify-center items-center p-3 md:p-4">
              {/* <div>
                                <img
                                    // src={employeeData[currentImageIndex]?.imageUrl}
                                    src={`https://trackforces.blob.core.windows.net/video/${employeeData[currentImageIndex]?.image_id}?sp=racwdl&st=2025-05-05T12:10:22Z&se=2026-06-30T20:10:22Z&spr=https&sv=2024-11-04&sr=c&sig=TSWNi2Y7lr0wUZK%2BEyCaK3wp7uWe%2FKIValAPdxyFVo4%3D`}
                                    alt="Current Screenshot"
                                    style={{ minWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
                                />
                            </div> */}
              <div className="space-y-2 max-w-[65%]">
                <img
                  // src={employeeData[currentImageIndex]?.imageUrl}
                  src={`data:${employeeData[currentImageIndex]?.image_content_type};base64,${employeeData[currentImageIndex]?.image_event}`}
                  alt="Current Screenshot"
                  style={{
                    minWidth: '100%',
                    maxHeight: '70vh',
                    objectFit: 'contain',
                  }}
                />
                <div className="pt-[14px] flex justify-between gap-1 items-center">
                  <Typography.Title
                    level={4}
                    style={{ margin: 0 }}
                    className="!font-medium !text-sm "
                  >
                    {employeeData[index]?.emp_name}
                  </Typography.Title>
                  <small style={{ color: token?.colorTextSecondary }} className=" gap-[2px] flex items-center text-end my-time">
                    <div className="font-bold flex items-center gap-[2px]">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.25 1.5H12.375V0.875C12.375 0.70924 12.3092 0.550268 12.1919 0.433058C12.0747 0.315848 11.9158 0.25 11.75 0.25C11.5842 0.25 11.4253 0.315848 11.3081 0.433058C11.1908 0.550268 11.125 0.70924 11.125 0.875V1.5H4.875V0.875C4.875 0.70924 4.80915 0.550268 4.69194 0.433058C4.57473 0.315848 4.41576 0.25 4.25 0.25C4.08424 0.25 3.92527 0.315848 3.80806 0.433058C3.69085 0.550268 3.625 0.70924 3.625 0.875V1.5H1.75C1.41848 1.5 1.10054 1.6317 0.866116 1.86612C0.631696 2.10054 0.5 2.41848 0.5 2.75V15.25C0.5 15.5815 0.631696 15.8995 0.866116 16.1339C1.10054 16.3683 1.41848 16.5 1.75 16.5H14.25C14.5815 16.5 14.8995 16.3683 15.1339 16.1339C15.3683 15.8995 15.5 15.5815 15.5 15.25V2.75C15.5 2.41848 15.3683 2.10054 15.1339 1.86612C14.8995 1.6317 14.5815 1.5 14.25 1.5ZM3.625 2.75V3.375C3.625 3.54076 3.69085 3.69973 3.80806 3.81694C3.92527 3.93415 4.08424 4 4.25 4C4.41576 4 4.57473 3.93415 4.69194 3.81694C4.80915 3.69973 4.875 3.54076 4.875 3.375V2.75H11.125V3.375C11.125 3.54076 11.1908 3.69973 11.3081 3.81694C11.4253 3.93415 11.5842 4 11.75 4C11.9158 4 12.0747 3.93415 12.1919 3.81694C12.3092 3.69973 12.375 3.54076 12.375 3.375V2.75H14.25V5.25H1.75V2.75H3.625ZM14.25 15.25H1.75V6.5H14.25V15.25Z"
                          fill={token?.customSvgColorForScreenShootCard}
                        />
                      </svg>
                      <span>
                        {new Date(
                          employeeData[index]?.timestamp
                        ).toLocaleDateString('en-GB')}
                      </span>
                      ,
                    </div>{' '}
                    <div className="flex items-center gap-[2px]">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.5 0C5.21442 0 3.95772 0.381218 2.8888 1.09545C1.81988 1.80968 0.986756 2.82484 0.494786 4.01256C0.00281635 5.20028 -0.125905 6.50721 0.124899 7.76809C0.375703 9.02896 0.994767 10.1872 1.90381 11.0962C2.81285 12.0052 3.97104 12.6243 5.23192 12.8751C6.49279 13.1259 7.79973 12.9972 8.98744 12.5052C10.1752 12.0132 11.1903 11.1801 11.9046 10.1112C12.6188 9.04229 13 7.78558 13 6.5C12.9982 4.77665 12.3128 3.12441 11.0942 1.90582C9.87559 0.687224 8.22335 0.00181989 6.5 0ZM6.5 12C5.41221 12 4.34884 11.6774 3.44437 11.0731C2.5399 10.4687 1.83495 9.60975 1.41867 8.60476C1.00238 7.59977 0.893465 6.4939 1.10568 5.427C1.3179 4.36011 1.84173 3.3801 2.61092 2.61091C3.3801 1.84172 4.36011 1.3179 5.42701 1.10568C6.4939 0.893462 7.59977 1.00238 8.60476 1.41866C9.60976 1.83494 10.4687 2.53989 11.0731 3.44436C11.6774 4.34883 12 5.4122 12 6.5C11.9983 7.95818 11.4184 9.35617 10.3873 10.3873C9.35617 11.4184 7.95819 11.9983 6.5 12ZM10.5 6.5C10.5 6.63261 10.4473 6.75979 10.3536 6.85355C10.2598 6.94732 10.1326 7 10 7H6.5C6.36739 7 6.24022 6.94732 6.14645 6.85355C6.05268 6.75979 6 6.63261 6 6.5V3C6 2.86739 6.05268 2.74021 6.14645 2.64645C6.24022 2.55268 6.36739 2.5 6.5 2.5C6.63261 2.5 6.75979 2.55268 6.85356 2.64645C6.94732 2.74021 7 2.86739 7 3V6H10C10.1326 6 10.2598 6.05268 10.3536 6.14645C10.4473 6.24021 10.5 6.36739 10.5 6.5Z"
                          fill={token?.customSvgColorForScreenShootCard}
                        />
                      </svg>
                      <span>
                        {' '}
                        {new Date(employeeData[index]?.timestamp)
                          .toLocaleTimeString('en-US', {
                            hour: 'numeric',
                            minute: 'numeric',
                            hour12: true,
                          })
                          .toLowerCase()}
                      </span>
                    </div>
                  </small>
                </div>
                <Typography.Title level={4} style={{ margin: 0 }} className="text-start !font-medium !text-sm" >
                  <span className="font-semibold">Info:</span> {result || 'N/A'}
                </Typography.Title>
              </div>
              <div>
                {/* Previous Image Button */}
                <Button
                  className="absolute top-1/2 left-4 transform -translate-y-1/2 text-white bg-primaryColor rounded-full p-2"
                  disabled={currentImageIndex === 0}
                  onClick={() => {
                    setCurrentImageIndex((prev) =>
                      typeof prev === 'number' && prev > 0 ? prev - 1 : prev
                    );
                    goToPrevPage();
                  }}
                >
                  <LeftOutlined />
                </Button>
                {/* Next Image Button */}
                <Button
                  className="absolute top-1/2 right-4 transform -translate-y-1/2 text-white bg-primaryColor rounded-full p-2"
                  disabled={currentImageIndex === employeeData.length - 1}
                  onClick={() => {
                    setCurrentImageIndex((prev) =>
                      typeof prev === 'number' && prev < employeeData.length - 1
                        ? prev + 1
                        : prev
                    );
                    goToNextPage();
                  }}
                >
                  <RightOutlined />
                </Button>
              </div>
            </div>
            {/* Thumbnail Carousel */}
            <div className="mt-4 flex justify-center ">
              {thumbnailsToShow.map((image, index) => (
                <img
                  key={index}
                  src={`data:${image?.image_content_type};base64,${image?.image_event}`}
                  alt="Thumbnail"
                  className={`size-12 md:size-20 object-cover mx-1 cursor-pointer ${currentImageIndex === employeeData.indexOf(image)
                    ? 'border-4 border-blue-500'
                    : ''
                    }`}
                  onClick={() =>
                    handleThumbnailClick(employeeData.indexOf(image))
                  }
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default CommonMonitoringImageModal;
